<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-12">
                  <div class="formControl mt">
                    <pr-input-radio
                      formControlName="swisslifePrevoyance"
                      direction="column"
                      [isDefault]="false"
                      columns="3"
                      [options]="options"
                      label="Choix option prévoyance Swisslife"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
